import styled from 'astroturf/react'
import { Form } from '@calendly/form'
import { Button } from '@calendly/ui/components/button'
import { Link } from '@calendly/ui/components/link'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _InvoicePrintExclude from "styles-InvoicePrintExclude.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoicePrintExclude";
import _ScreenOnlyDocument from "styles-ScreenOnlyDocument.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=ScreenOnlyDocument";
import _PrintOnlyDocument from "styles-PrintOnlyDocument.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PrintOnlyDocument";
import _DownloadInvoiceLinkText from "styles-DownloadInvoiceLinkText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=DownloadInvoiceLinkText";
import _DownloadInvoiceLink from "styles-DownloadInvoiceLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=DownloadInvoiceLink";
import _ContentWrapper from "styles-ContentWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=ContentWrapper";
import _LeftColumn from "styles-LeftColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=LeftColumn";
import _RightColumn from "styles-RightColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=RightColumn";
import _FormWrapper from "styles-FormWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=FormWrapper";
import _StyledForm from "styles-StyledForm.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=StyledForm";
import _PaymentSection from "styles-PaymentSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PaymentSection";
import _TotalDueSection from "styles-TotalDueSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=TotalDueSection";
import _TotalDueLabel from "styles-TotalDueLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=TotalDueLabel";
import _TotalDueAmount from "styles-TotalDueAmount.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=TotalDueAmount";
import _FormFieldsWrapper from "styles-FormFieldsWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=FormFieldsWrapper";
import _BottomSection from "styles-BottomSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=BottomSection";
import _PageContainer from "styles-PageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PageContainer";
import _InvoiceHeader from "styles-InvoiceHeader.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeader";
import _InvoiceHeaderImageContainer from "styles-InvoiceHeaderImageContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeaderImageContainer";
import _InvoiceHeaderImage from "styles-InvoiceHeaderImage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeaderImage";
import _InvoiceHeaderImagePlaceholder from "styles-InvoiceHeaderImagePlaceholder.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeaderImagePlaceholder";
import _InvoiceHeaderRight from "styles-InvoiceHeaderRight.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeaderRight";
import _InvoiceNumberLabel from "styles-InvoiceNumberLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceNumberLabel";
import _InvoicePaidSummaryRow from "styles-InvoicePaidSummaryRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoicePaidSummaryRow";
import _InvoicePaidSummaryText from "styles-InvoicePaidSummaryText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoicePaidSummaryText";
import _InvoiceLeftColumnContent from "styles-InvoiceLeftColumnContent.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLeftColumnContent";
import _InvoicePaidWatermark from "styles-InvoicePaidWatermark.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoicePaidWatermark";
import _InvoicePaidStamp from "styles-InvoicePaidStamp.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoicePaidStamp";
import _InvoiceDetails from "styles-InvoiceDetails.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetails";
import _InvoiceDetailLabel from "styles-InvoiceDetailLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailLabel";
import _InvoiceDetailBodyLine from "styles-InvoiceDetailBodyLine.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailBodyLine";
import _InvoiceDetailColumn from "styles-InvoiceDetailColumn.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailColumn";
import _InvoiceDetailColumnRight from "styles-InvoiceDetailColumnRight.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailColumnRight";
import _InvoiceDetailDateText from "styles-InvoiceDetailDateText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDetailDateText";
import _InvoiceDueDateBlock from "styles-InvoiceDueDateBlock.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceDueDateBlock";
import _InvoiceAmountDueValue from "styles-InvoiceAmountDueValue.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceAmountDueValue";
import _InvoiceLineItemsSection from "styles-InvoiceLineItemsSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsSection";
import _InvoiceLineItemsTable from "styles-InvoiceLineItemsTable.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsTable";
import _InvoiceLineItemsHeaderCellDescription from "styles-InvoiceLineItemsHeaderCellDescription.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsHeaderCellDescription";
import _InvoiceLineItemsHeaderCellRight from "styles-InvoiceLineItemsHeaderCellRight.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsHeaderCellRight";
import _InvoiceLineItemsRow from "styles-InvoiceLineItemsRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsRow";
import _InvoiceLineItemsCellDescription from "styles-InvoiceLineItemsCellDescription.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsCellDescription";
import _InvoiceLineItemsCell from "styles-InvoiceLineItemsCell.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsCell";
import _InvoiceLineItemsCellRight from "styles-InvoiceLineItemsCellRight.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemsCellRight";
import _InvoiceLineItemName from "styles-InvoiceLineItemName.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemName";
import _InvoiceLineItemDescription from "styles-InvoiceLineItemDescription.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemDescription";
import _InvoiceLineItemMobileMeta from "styles-InvoiceLineItemMobileMeta.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemMobileMeta";
import _InvoiceLineItemMobileMetaItem from "styles-InvoiceLineItemMobileMetaItem.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemMobileMetaItem";
import _InvoiceTotalsSection from "styles-InvoiceTotalsSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsSection";
import _InvoiceTotalsRow from "styles-InvoiceTotalsRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsRow";
import _InvoiceTotalsRowDiscount from "styles-InvoiceTotalsRowDiscount.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsRowDiscount";
import _InvoiceTotalsRowTotal from "styles-InvoiceTotalsRowTotal.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsRowTotal";
import _InvoiceTotalsLabel from "styles-InvoiceTotalsLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsLabel";
import _InvoiceTotalsValue from "styles-InvoiceTotalsValue.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceTotalsValue";
import _InvoiceNotesSection from "styles-InvoiceNotesSection.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceNotesSection";
import _InvoiceNotesLabel from "styles-InvoiceNotesLabel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceNotesLabel";
import _InvoiceNotesBody from "styles-InvoiceNotesBody.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceNotesBody";
import _SubmitErrorMessage from "styles-SubmitErrorMessage.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=SubmitErrorMessage";
import _Footer from "styles-Footer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=Footer";
import _LogoWrapper from "styles-LogoWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=LogoWrapper";
import _FooterLinks from "styles-FooterLinks.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=FooterLinks";
import _FooterLink from "styles-FooterLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=FooterLink";
import _RightColumnContent from "styles-RightColumnContent.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=RightColumnContent";
import _InvoiceHeroCard from "styles-InvoiceHeroCard.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeroCard";
import _InvoiceHeroNumber from "styles-InvoiceHeroNumber.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeroNumber";
import _InvoiceHeroAmount from "styles-InvoiceHeroAmount.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeroAmount";
import _InvoiceHeroDue from "styles-InvoiceHeroDue.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceHeroDue";
import _InvoiceBillingGrid from "styles-InvoiceBillingGrid.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceBillingGrid";
import _PhoneInvoicePayCta from "styles-PhoneInvoicePayCta.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhoneInvoicePayCta";
import _PhonePaymentSummary from "styles-PhonePaymentSummary.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSummary";
import _PhonePaymentSummaryTitle from "styles-PhonePaymentSummaryTitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSummaryTitle";
import _PhonePaymentSummarySubtitle from "styles-PhonePaymentSummarySubtitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSummarySubtitle";
import _PhoneViewInvoiceButton from "styles-PhoneViewInvoiceButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhoneViewInvoiceButton";
import _PhonePaymentSuccessContainer from "styles-PhonePaymentSuccessContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessContainer";
import _PhonePaymentSuccessIcon from "styles-PhonePaymentSuccessIcon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessIcon";
import _PhonePaymentSuccessTitle from "styles-PhonePaymentSuccessTitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessTitle";
import _PhonePaymentSuccessTitleGroup from "styles-PhonePaymentSuccessTitleGroup.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessTitleGroup";
import _PhonePaymentSuccessDescription from "styles-PhonePaymentSuccessDescription.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessDescription";
import _PhonePaymentSuccessDetails from "styles-PhonePaymentSuccessDetails.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessDetails";
import _PhonePaymentSuccessDetailRow from "styles-PhonePaymentSuccessDetailRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessDetailRow";
import _PhonePaymentSuccessDetailText from "styles-PhonePaymentSuccessDetailText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessDetailText";
import _PhonePaymentSuccessConfirmation from "styles-PhonePaymentSuccessConfirmation.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessConfirmation";
import _PhonePaymentSuccessDownloadButton from "styles-PhonePaymentSuccessDownloadButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhonePaymentSuccessDownloadButton";
import _InvoiceLineItemNameRow from "styles-InvoiceLineItemNameRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemNameRow";
import _InvoiceLineItemAmount from "styles-InvoiceLineItemAmount.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=InvoiceLineItemAmount";
import _PhoneDownloadInvoiceCta from "styles-PhoneDownloadInvoiceCta.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/invoice/styles.js?styleId=PhoneDownloadInvoiceCta";

const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
const colorBackgroundTertiary = 'var(--colorBackgroundTertiary, var(--coreColorNeutral300))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorTextSuccess = 'var(--colorTextSuccess, var(--coreColorGreen800))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
const colorTextDestructive = 'var(--colorTextDestructive, var(--coreColorRed700))'
const colorSurfaceSuccess = 'var(--colorSurfaceSuccess, var(--coreColorGreen700))'
const fontFamilyHeading = 'var(--fontFamilyHeading, "Proxima Nova", sans-serif)'
const fontSizeSmall = 'var(--fontSizeSmall, 0.75rem)'
const fontSizeLabelMedium = 'var(--fontSizeLabelMedium, 0.75rem)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontSizeLarge = 'var(--fontSizeLarge, 1rem)'
const fontSizeTitleLarge = 'var(--fontSizeTitleLarge, 1.375rem)'
const lineHeightLabelMedium = 'var(--lineHeightLabelMedium, 1rem)'
const lineHeightLabelLarge = 'var(--lineHeightLabelLarge, 1.25rem)'
const lineHeightStandard = 'var(--lineHeightStandard, 1.5)'
const fontWeightStandard = 'var(--fontWeightStandard, 400)'
const fontWeightSemibold = 'var(--fontWeightSemibold, 600)'
const fontWeightBold = 'var(--fontWeightBold, 700)'

/**
 * Invoice print convention
 *
 * - Document content inside InvoiceLeftColumnContent is included in print by default.
 * - Wrap interactive or non-document UI in InvoicePrintExclude to opt out of print.
 * - Do not use isPhone/isTabletDown JSX conditionals for document content; always render
 *   and use @media screen CSS (see ScreenOnlyDocument / PrintOnlyDocument) so print gets
 *   the full desktop DOM.
 * - UI outside LeftColumn (e.g. RightColumn) must opt out explicitly — see RightColumn.
 */
export const InvoicePrintExclude = /*#__PURE__*/styled('div', null, {
  displayName: "InvoicePrintExclude",
  styles: _InvoicePrintExclude
})

export const ScreenOnlyDocument = /*#__PURE__*/styled('div', null, {
  displayName: "ScreenOnlyDocument",
  styles: _ScreenOnlyDocument
})

export const PrintOnlyDocument = /*#__PURE__*/styled('div', null, {
  displayName: "PrintOnlyDocument",
  styles: _PrintOnlyDocument
})

export const DownloadInvoiceLinkText = /*#__PURE__*/styled('span', null, {
  displayName: "DownloadInvoiceLinkText",
  styles: _DownloadInvoiceLinkText
})

/* Rendered as a button (as="button") for print-action semantics; the Link
   styling gives the action color. Underline on hover/focus applies to the
   label text only, not the icon. */
export const DownloadInvoiceLink = /*#__PURE__*/styled(Link, null, {
  displayName: "DownloadInvoiceLink",
  styles: _DownloadInvoiceLink
})

/** Invoice checkout card — desktop: max 1250px (822 + 428); paid-only single column caps at 800px */
export const ContentWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "ContentWrapper",
  styles: _ContentWrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const LeftColumn = /*#__PURE__*/styled('div', null, {
  displayName: "LeftColumn",
  styles: _LeftColumn,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const RightColumn = /*#__PURE__*/styled('div', null, {
  displayName: "RightColumn",
  styles: _RightColumn,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const FormWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "FormWrapper",
  styles: _FormWrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const StyledForm = /*#__PURE__*/styled(Form, null, {
  displayName: "StyledForm",
  styles: _StyledForm
})

export const PaymentSection = /*#__PURE__*/styled("div", null, {
  displayName: "PaymentSection",
  styles: _PaymentSection
})

export const TotalDueSection = /*#__PURE__*/styled('div', null, {
  displayName: "TotalDueSection",
  styles: _TotalDueSection
})

export const TotalDueLabel = /*#__PURE__*/styled('div', null, {
  displayName: "TotalDueLabel",
  styles: _TotalDueLabel
})

export const TotalDueAmount = /*#__PURE__*/styled('div', null, {
  displayName: "TotalDueAmount",
  styles: _TotalDueAmount
})

export const FormFieldsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "FormFieldsWrapper",
  styles: _FormFieldsWrapper
})

export const BottomSection = /*#__PURE__*/styled('div', null, {
  displayName: "BottomSection",
  styles: _BottomSection,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const PageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "PageContainer",
  styles: _PageContainer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceHeader = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeader",
  styles: _InvoiceHeader,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceHeaderImageContainer = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeaderImageContainer",
  styles: _InvoiceHeaderImageContainer,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceHeaderImage = /*#__PURE__*/styled('img', null, {
  displayName: "InvoiceHeaderImage",
  styles: _InvoiceHeaderImage,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceHeaderImagePlaceholder = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeaderImagePlaceholder",
  styles: _InvoiceHeaderImagePlaceholder
})

export const InvoiceHeaderRight = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeaderRight",
  styles: _InvoiceHeaderRight,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceNumberLabel = /*#__PURE__*/styled('span', null, {
  displayName: "InvoiceNumberLabel",
  styles: _InvoiceNumberLabel,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoicePaidSummaryRow = /*#__PURE__*/styled('div', null, {
  displayName: "InvoicePaidSummaryRow",
  styles: _InvoicePaidSummaryRow,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoicePaidSummaryText = /*#__PURE__*/styled('span', null, {
  displayName: "InvoicePaidSummaryText",
  styles: _InvoicePaidSummaryText
})

export const InvoiceLeftColumnContent = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLeftColumnContent",
  styles: _InvoiceLeftColumnContent
})

export const InvoicePaidWatermark = /*#__PURE__*/styled('div', null, {
  displayName: "InvoicePaidWatermark",
  styles: _InvoicePaidWatermark,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoicePaidStamp = /*#__PURE__*/styled('div', null, {
  displayName: "InvoicePaidStamp",
  styles: _InvoicePaidStamp
})

export const InvoiceDetails = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetails",
  styles: _InvoiceDetails,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceDetailLabel = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailLabel",
  styles: _InvoiceDetailLabel
})

export const InvoiceDetailBodyLine = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailBodyLine",
  styles: _InvoiceDetailBodyLine
})

export const InvoiceDetailColumn = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailColumn",
  styles: _InvoiceDetailColumn,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceDetailColumnRight = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailColumnRight",
  styles: _InvoiceDetailColumnRight,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceDetailDateText = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDetailDateText",
  styles: _InvoiceDetailDateText
})

export const InvoiceDueDateBlock = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceDueDateBlock",
  styles: _InvoiceDueDateBlock
})

export const InvoiceAmountDueValue = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceAmountDueValue",
  styles: _InvoiceAmountDueValue
})

export const InvoiceLineItemsSection = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLineItemsSection",
  styles: _InvoiceLineItemsSection,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceLineItemsTable = /*#__PURE__*/styled('table', null, {
  displayName: "InvoiceLineItemsTable",
  styles: _InvoiceLineItemsTable
})

export const InvoiceLineItemsHeaderCellDescription = /*#__PURE__*/styled('th', null, {
  displayName: "InvoiceLineItemsHeaderCellDescription",
  styles: _InvoiceLineItemsHeaderCellDescription,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const invoiceLineItemsNumericColumnWidth = '112px'

export const InvoiceLineItemsHeaderCellRight = /*#__PURE__*/styled('th', null, {
  displayName: "InvoiceLineItemsHeaderCellRight",
  styles: _InvoiceLineItemsHeaderCellRight,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceLineItemsRow = /*#__PURE__*/styled('tr', null, {
  displayName: "InvoiceLineItemsRow",
  styles: _InvoiceLineItemsRow
})

export const InvoiceLineItemsCellDescription = /*#__PURE__*/styled('td', null, {
  displayName: "InvoiceLineItemsCellDescription",
  styles: _InvoiceLineItemsCellDescription
})

export const InvoiceLineItemsCell = /*#__PURE__*/styled('td', null, {
  displayName: "InvoiceLineItemsCell",
  styles: _InvoiceLineItemsCell
})

export const InvoiceLineItemsCellRight = /*#__PURE__*/styled('td', null, {
  displayName: "InvoiceLineItemsCellRight",
  styles: _InvoiceLineItemsCellRight,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceLineItemName = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLineItemName",
  styles: _InvoiceLineItemName
})

export const InvoiceLineItemDescription = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLineItemDescription",
  styles: _InvoiceLineItemDescription
})

export const InvoiceLineItemMobileMeta = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLineItemMobileMeta",
  styles: _InvoiceLineItemMobileMeta,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceLineItemMobileMetaItem = /*#__PURE__*/styled('span', null, {
  displayName: "InvoiceLineItemMobileMetaItem",
  styles: _InvoiceLineItemMobileMetaItem
})

export const InvoiceTotalsSection = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceTotalsSection",
  styles: _InvoiceTotalsSection,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceTotalsRow = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceTotalsRow",
  styles: _InvoiceTotalsRow,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceTotalsRowDiscount = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceTotalsRowDiscount",
  styles: _InvoiceTotalsRowDiscount,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceTotalsRowTotal = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceTotalsRowTotal",
  styles: _InvoiceTotalsRowTotal,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const InvoiceTotalsLabel = /*#__PURE__*/styled('span', null, {
  displayName: "InvoiceTotalsLabel",
  styles: _InvoiceTotalsLabel
})

export const InvoiceTotalsValue = /*#__PURE__*/styled('span', null, {
  displayName: "InvoiceTotalsValue",
  styles: _InvoiceTotalsValue
})

export const InvoiceNotesSection = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceNotesSection",
  styles: _InvoiceNotesSection
})

export const InvoiceNotesLabel = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceNotesLabel",
  styles: _InvoiceNotesLabel
})

export const InvoiceNotesBody = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceNotesBody",
  styles: _InvoiceNotesBody
})

export const SubmitErrorMessage = /*#__PURE__*/styled('div', null, {
  displayName: "SubmitErrorMessage",
  styles: _SubmitErrorMessage
})

export const Footer = /*#__PURE__*/styled('div', null, {
  displayName: "Footer",
  styles: _Footer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const LogoWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "LogoWrapper",
  styles: _LogoWrapper
})

export const FooterLinks = /*#__PURE__*/styled('div', null, {
  displayName: "FooterLinks",
  styles: _FooterLinks
})

export const FooterLink = /*#__PURE__*/styled('button', null, {
  displayName: "FooterLink",
  styles: _FooterLink
})

export const RightColumnContent = /*#__PURE__*/styled('div', null, {
  displayName: "RightColumnContent",
  styles: _RightColumnContent,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

export const InvoiceHeroCard = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeroCard",
  styles: _InvoiceHeroCard
})

export const InvoiceHeroNumber = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeroNumber",
  styles: _InvoiceHeroNumber
})

export const InvoiceHeroAmount = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeroAmount",
  styles: _InvoiceHeroAmount
})

export const InvoiceHeroDue = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceHeroDue",
  styles: _InvoiceHeroDue
})

export const InvoiceBillingGrid = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceBillingGrid",
  styles: _InvoiceBillingGrid
})

export const PhoneInvoicePayCta = /*#__PURE__*/styled('div', null, {
  displayName: "PhoneInvoicePayCta",
  styles: _PhoneInvoicePayCta
})

/* COM-763: rendered only on phone via JS isPhone gating in index.js */
export const PhonePaymentSummary = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSummary",
  styles: _PhonePaymentSummary
})

export const PhonePaymentSummaryTitle = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSummaryTitle",
  styles: _PhonePaymentSummaryTitle
})

export const PhonePaymentSummarySubtitle = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSummarySubtitle",
  styles: _PhonePaymentSummarySubtitle
})

export const PhoneViewInvoiceButton = /*#__PURE__*/styled(Button, null, {
  displayName: "PhoneViewInvoiceButton",
  styles: _PhoneViewInvoiceButton,
  attrs: props => ({
    ...props,
    appearance: 'secondary-outline',
    size: 'small'
  })
})

export const PhonePaymentSuccessContainer = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSuccessContainer",
  styles: _PhonePaymentSuccessContainer
})

export const PhonePaymentSuccessIcon = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSuccessIcon",
  styles: _PhonePaymentSuccessIcon
})

export const PhonePaymentSuccessTitle = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSuccessTitle",
  styles: _PhonePaymentSuccessTitle
})

export const PhonePaymentSuccessTitleGroup = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSuccessTitleGroup",
  styles: _PhonePaymentSuccessTitleGroup
})

export const PhonePaymentSuccessDescription = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSuccessDescription",
  styles: _PhonePaymentSuccessDescription
})

export const PhonePaymentSuccessDetails = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSuccessDetails",
  styles: _PhonePaymentSuccessDetails
})

export const PhonePaymentSuccessDetailRow = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSuccessDetailRow",
  styles: _PhonePaymentSuccessDetailRow
})

export const PhonePaymentSuccessDetailText = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSuccessDetailText",
  styles: _PhonePaymentSuccessDetailText
})

export const PhonePaymentSuccessConfirmation = /*#__PURE__*/styled('div', null, {
  displayName: "PhonePaymentSuccessConfirmation",
  styles: _PhonePaymentSuccessConfirmation
})

export const PhonePaymentSuccessDownloadButton = /*#__PURE__*/styled(Button, null, {
  displayName: "PhonePaymentSuccessDownloadButton",
  styles: _PhonePaymentSuccessDownloadButton
})

export const InvoiceLineItemNameRow = /*#__PURE__*/styled('div', null, {
  displayName: "InvoiceLineItemNameRow",
  styles: _InvoiceLineItemNameRow
})

export const InvoiceLineItemAmount = /*#__PURE__*/styled('span', null, {
  displayName: "InvoiceLineItemAmount",
  styles: _InvoiceLineItemAmount
})

export const PhoneDownloadInvoiceCta = /*#__PURE__*/styled('div', null, {
  displayName: "PhoneDownloadInvoiceCta",
  styles: _PhoneDownloadInvoiceCta
})
